import React from 'react';
import { getGoogleLoginUrl } from '../services/api';
import BrandLockup from './BrandLockup';

export default function GoogleLoginScreen() {
  const params = new URLSearchParams(window.location.search);
  const error = params.get('error');

  function handleLogin() {
    window.location.href = getGoogleLoginUrl();
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <BrandLockup className="login-brand" />

        <h1 className="login-title">Bank reconciliation,<br />done by AI</h1>
        <p className="login-sub">
          Sign in with your Melon Accountants or Melon Tax Google account to continue.
        </p>

        {error === 'access_denied' && (
          <p className="login-error">
            Access denied. Only melonaccountants.co.uk and melontax.co.uk accounts are allowed.
          </p>
        )}

        <button className="btn-google" onClick={handleLogin}>
          <svg width="20" height="20" viewBox="0 0 48 48" fill="none">
            <path d="M44.5 20H24v8.5h11.8C34.7 33.9 29.8 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z" fill="#FFC107"/>
            <path d="M6.3 14.7l7 5.1C15.1 16.1 19.2 13 24 13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 16.3 2 9.7 7.4 6.3 14.7z" fill="#FF3D00"/>
            <path d="M24 46c5.5 0 10.5-1.9 14.3-5.1l-6.6-5.6C29.7 36.9 27 38 24 38c-5.7 0-10.6-3.9-11.8-9.1l-7 5.4C8.1 41.8 15.5 46 24 46z" fill="#4CAF50"/>
            <path d="M44.5 20H24v8.5h11.8c-.6 2.8-2.3 5.2-4.7 6.8l6.6 5.6C42 37.3 45 31.1 45 24c0-1.3-.2-2.7-.5-4z" fill="#1976D2"/>
          </svg>
          Sign in with Google
        </button>

        <p className="login-footer">
          Melon Accountants · Powered by Claude AI
        </p>
      </div>
    </div>
  );
}
